import client from "api/client";


const _client = client.route("/payment");

const pay = {
	deposit: (payload) => _client.post("", payload),
	getDeposits: (payload) => _client.post("/deposits", payload)
};

export default pay;